<template>
  <div class="product-category-filter">
    <h4>
      <button class="menu-icon" :class="{ 'active': mobileShow }" @click="mobileShow = !mobileShow"><img :src="menuicon" /></button>
      Categories <span class="selected-number" v-if="selected.length > 0">({{selected.length}})</span>
    </h4>
    <div class="content" :class="{ 'show': mobileShow }">
      <ul class="categories-list">
        <li>
          <label>
            <input type="checkbox" v-model="allSelected" @click="selectAll" /> All
          </label>
        </li>
        <li v-for="(c, i) in categories" :key="i">
          <label>
            <input type="checkbox" v-model="selected" :value="c.tid" />{{c.name}}
            <div style="display:flex; flex: 1;"></div>
            <div class="color-label" :style="`background-color: ${c.color.color}`" v-if="c.color"></div>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },
  data() {
    return {
      allSelected: true,
      selected: [],
      menuicon: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAMAAABrrFhUAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABd1BMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHx8AAAAkICAjHyAjHyAjHyAjHyAjHyAjHyAkHyAjHyAjHyAjHyAjHyAjHyAfHx8jHyAkHyEjHyAjHyAkICAjHyAjHyAjHyEjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHx8jHyAjHyAjHyAjHyAjHyAjHyAjHyAjISEiHiAiHiAjHyEAAAAjHyAjHyAjHyAjHyAjHyAiHCIjHyAjHyAjHyAgICAkHyAjHyAjHyAjHyAjHyAjHyAiHiEjHyAjHyAjHx8jHyAjHyAjHyAjHyAjHyAhISEjHyAjHyAjHyAjHyAjHyAjHSMjHyAiHiAjHiEiHiAjHyAjHyAjHyAjHyAjHyAjHyAjHx8jHyAjHyAjHyAiHiAjHyAjHyAjHyAjHyAjHyAjHyAjHyAjHx8jHyAjHyAjHyAgICAjHyAjHyAjHyAjHyAjICAlICAjHyAjHyAjHyAjHyAkHyAjHyAjHyAjHyAjHyAjHyBGelv3AAAAfHRSTlMAGFpubmYyAAOK+sEgnuEVP/+XmO8CuhSq+wdmvgjY/D0k2/hfCm62y8zCjSQLHR4VADvA/d9xA1n8rAIe9W2C27UPgtoe9WxZ+6wCOr/833ADCx0UC262y8KOJSTb+GAI2fw9Zr6r+wi6mO8BPped4RUDifnBHxhabmYy57hCCQAAAWNJREFUGBntwQOOGAAQAMAtr7Zt226vtm3bxj6+f2iyySadmQAAAAAAAAAAAAAAAAAAAADg/zFk6LDhXY0YORDFRo0ek52NHRe1xmdzEyZGpUmTs7spUWlqtjdtehSakf3NjEKzsr3Zc6LQ3GxvXlSavyCbW7goSi1ekq0tXRbFlq9YuWp1V2vWrgsAAAAAAAAAAAAAAP7J+g0bu9q0Ocpt2bot+9q+Y2fU2rU7e9uzNyrt25/dHYhKB7O9Q1FpMPs7HIUGs7/DUehItnc0Kh07nt2diFInT2Vvp89ErbPnzmdfFy5einKXr2zs6upAAAAAAAAAAAAAAADwL65dv3FzdVe3bt+JYnfvZWv3H0Sph4+yucdPotLTbO9ZVHqe7b14GYVeZX8zo9DrbO/N2yj0bnJ29z5KfcjmPn6KUp+/fM3Ovn2Paj9+/hre1e8/AwEAAAAAAAAAAAAAAAAAAADA/+kvovALfy7Ti50AAAAASUVORK5CYII=`,
      mobileShow: false
    }
  },
  methods: {
    selectAll() {
      this.selected = (this.selected.length < this.categories.length) ? [...this.categories.map(c => c.tid)] : []
    }
  },
  watch: {
    categories(val) {
      if (this.selected.length === 0) {
        this.selected = [...this.categories.map(c => c.tid)]
      }
    },
    selected(val) {
      if (val.length < this.categories.length) {
        this.allSelected = false
      } else {
        this.allSelected = true
      }
      this.$emit('input',this.selected)
    }
  }
}
</script>

<style>
  .product-category-filter .menu-icon {
    margin: 0;
    padding: 0;
    vertical-align: middle;
    cursor: pointer;
    border:none;
    display: none;
    background-color: #fff;
  }
  .product-category-filter .menu-icon.active {
    background-color: #efefef;
  }
  .product-category-filter .menu-icon img {
    max-width: 28px;
  }
  .product-category-filter {
    padding: 4px;
    box-shadow: 0 0 4px rgba(0, 0, 0, .3);
    position: relative;
    background-color: #fff;
    font-family: Arial, Helvetica, sans-serif;
    overflow: hidden;
  }
  .product-category-filter h4 {
    margin: 0;
    padding: 10px 10px;
    font-size: 16px;
  }
  .product-category-filter ul.categories-list {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  .product-category-filter ul.categories-list li {
    list-style: none;
    color: #0578be;
    cursor: pointer;
    padding: 5px 5px;
    font-size: 12px;
    display: block;
    box-sizing: border-box;
    display: block;
    border-bottom: 1px solid #efefef;
  }
  .product-category-filter ul.categories-list li:last-child {
    border-bottom: none;
  }
  .product-category-filter ul.categories-list li label {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: normal;
  }
  .product-category-filter ul.categories-list li input[type="checkbox"] {
    margin: 0 5px 0 0;
    zoom: 1.3;
  }
  .product-category-filter .apply-filter {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px 8px;
    margin: 15px auto;
    cursor: pointer;
    background-color: #fff;
    display: block;
    font-size: 12px;
    color: #000;
  }
  .product-category-filter ul.categories-list li .color-label {
    width: 10px;
    height: 10px;
    font-size: 1px;
    border-radius: 100px;
  }
  .product-category-filter .apply-filter:hover {
    background-color: #efefef;
  }
  .product-category-filter .content {
    overflow-y: auto;
    max-height: 300px;
  }
  @media screen and (max-width: 768px) {
    .product-category-filter .content {
      display: none;
    }
    .product-category-filter .content.show {
      display: block;
    }
    .product-category-filter .menu-icon {
      display: inline-block;
    }
    .product-category-filter .menu-icon:focus {
      outline: none;
    }
  }
</style>